'use client';
import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

interface Props {
  data: { month: string; gsv: number; activeCount: number; commissions: number }[];
}

// Simulate active rate from activeCount
const TOTAL_DISTS = 21;

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-zinc-800 border border-zinc-700 rounded-lg px-3 py-2 shadow-xl">
      <p className="text-xs font-semibold text-zinc-300 mb-1">{label}</p>
      <p className="text-xs font-mono text-emerald-400">{payload[0]?.value?.toFixed(1)}% active rate</p>
    </div>
  );
};

export default function ActiveRateTrendChart({ data }: Props) {
  const chartData = data.map(d => ({
    ...d,
    activeRate: parseFloat(((d.activeCount / TOTAL_DISTS) * 100).toFixed(1)),
  }));

  return (
    <div className="bg-zinc-900 border border-zinc-800 rounded-2xl p-5">
      <div className="flex items-center justify-between mb-3">
        <h3 className="text-sm font-semibold text-zinc-300">Active Rate Trend</h3>
        <span className="text-[10px] text-zinc-600">% of network meeting 100 PSV</span>
      </div>
      <ResponsiveContainer width="100%" height={200}>
        <LineChart data={chartData} margin={{ top: 4, right: 4, left: -20, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" />
          <XAxis dataKey="month" tick={{ fontSize: 10, fill: '#71717a' }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fontSize: 9, fill: '#71717a' }} axisLine={false} tickLine={false} domain={[60, 100]} tickFormatter={v => `${v}%`} />
          <Tooltip content={<CustomTooltip />} />
          <Line type="monotone" dataKey="activeRate" stroke="#34d399" strokeWidth={2} dot={{ fill: '#34d399', r: 3 }} activeDot={{ r: 5 }} />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}